module.exports = __webpack_public_path__ + "img/ht_icon_search_2_line.a5b476dd.svg";